import { g as getDateFromDatepicker } from './get-date-from-datepicker.js';
import './index3.js';

/**
 * **Open Room**
 *
 * Official: https://bookings.open-room.com
 *
 * Example: <a href="http://www.hotelillador.com/es/" target="_blank">Hotel Illa DOr</a>
 *
 * @exports bs_40
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_40
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      let aux;
      const langObj = {
        1: 'es',
        2: 'en',
        3: 'de',
        4: 'fr',
        6: 'it',
        7: 'ca',
        8: 'pt',
      };

      aux = window.location.pathname.match(ctx.urlRe);
      aux = aux && aux[1];
      if (ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      thn.domReady().then(function () {

        const $ = window.jQuery;

        if ($ && $('input[name="Language"]').val()) {
          const langIdx = $('input[name="Language"]').val();
          aux = langObj[langIdx];
          if (ctx.langs.test(aux)) {
            resolve(aux);
            return;
          }
        }

        aux = (thn.parseUrlParameter('lang').match(/\w{2}/) || [])[0];
        if (ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        aux = (ctx.getHtmlLang() || window.culture || 'en').substr(0, 2);
        if (ctx.langs.test(aux)) {
          resolve(aux);
          return;
        }

        reject('no_language');
      });
    });
  };

  /**
     * @memberOf module:bs_40
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    if (window.setCurrency) {
      (function () {
        const _setCurrency = window.setCurrency;
        window.setCurrency = function () {
          // call the original function
          _setCurrency.apply(this, arguments);
          // do thn stuff
          ctx.widget.update();
        };
      }());
    }
  };

  /**
     *
     * Implements **noRooms**.
     *
     * @memberOf module:bs_40
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) { return widgetData; }

    let dateBegin = getDateFromDatepicker('#HotelRequest_Checkin');
    let dateEnd = getDateFromDatepicker('#HotelRequest_Checkout');

    if (!dateBegin || !dateEnd) {
      dateBegin = ($('#HotelRequest_Checkin').val() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
      dateEnd = ($('#HotelRequest_Checkout').val() || '').replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1');
    }

    widgetData.dateBegin = dateBegin;
    widgetData.dateEnd = dateEnd;

    widgetData.adults = 0;
    widgetData.children = 0;
    $('.room-age').each(function (idx, el) {
      var $el = $(el);
      var room = $el.data('room');
      widgetData.adults += parseInt($(`[name="room-${room}-adults"]`, $el).val(), 10) || 0;
      widgetData.children += parseInt($(`[name="room-${room}-children"]`, $el).val(), 10) || 0;
    });
    widgetData.guests = widgetData.adults + widgetData.children;

    // if not avoiding the RESIDENTS RATE, then the simpler ".amount" selector should be used
    let prices = $('.room-accomodation-rate:not([data-rate-name-opr="RESID"]) + td + td + td + td .amount, .amount.prices-table-price.price-best').map(function (idx, el) {
      return thn.parseNumber($(el).text().trim());
    }).toArray();

    // If it's a version where whe don't need to exclude rates (because it works in a different way) use the simpler way.
    if (thn.data.accountUserId === 1033102) {
      prices = $('.amount.prices-table-price.price-best').map(function (idx, el) {
        return thn.parseNumber($(el).text().trim());
      }).toArray();
    }

    if (prices.length
            && widgetData.dateBegin
            && widgetData.dateEnd) {
      widgetData.price = Math.min.apply(null, prices);
      widgetData.price /= thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      widgetData.currency = window.currency.Nombre || $('#currencyId option:selected').text();
      widgetData.set = true;

    } else if ($('.no-dispo').length) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * TODO: implement **bookingId**.
     *
     * @memberOf module:bs_40
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;
    const dataLayer = window.dataLayer;

    // Price
    widgetData.price = thn.parseNumber($('.checkout-total-amount td:last-child').text().trim());

    // Currency
    widgetData.currency = (window.currency && window.currencyNombre) || (dataLayer && thn.arrayGet(dataLayer, 'currencyUsedOR')) || ctx.tmpSession.currency;

    // Booking ID
    let bookingId = window.dataLayer && thn.arrayGet(dataLayer, 'transactionId');
    if (bookingId) { bookingId = bookingId.split('-'); }
    if (bookingId.length) { bookingId = bookingId[0].trim(); }
    widgetData.bookingId = bookingId;

    const parts = $('.checkout-table:eq(0) td:last-child').text().trim().match(/(\d{2})\D(\d{2})\D(\d{4})\D+(\d{2})\D(\d{2})\D(\d{4})/);
    if (parts.length === 7) {
      widgetData.dateBegin = `${parts[3]}/${parts[2]}/${parts[1]}`;
      widgetData.dateEnd = `${parts[6]}/${parts[5]}/${parts[4]}`;
    } else if (ctx.tmpSession.dateBegin != null && ctx.tmpSession.dateEnd != null) {
      widgetData.dateBegin = ctx.tmpSession.dateBegin;
      widgetData.dateEnd = ctx.tmpSession.dateEnd;
    }

    const promoEl = document.querySelector('.obj-details-oferta');
    if (promoEl) {
      widgetData.promocode = promoEl.textContent.trim();
    }

    return widgetData;
  };

  return engine;

}

export { factory };
